import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { IBlotterDefinitionPromiseLookupService } from "../IBlotterDefinitionPromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class BlotterDefinitionPromiseLookupService
  extends PromiseLookupService<string, CubiqTS.BlotterDefinitionImpl>
  implements IBlotterDefinitionPromiseLookupService
{
  constructor() {
    super();
  }

  abstract getBlotterDefinition(code: string): Promise<CubiqTS.BlotterDefinitionImpl>;
  abstract getMyBlotterDefinitions(): Promise<Array<CubiqTS.BlotterDefinitionImpl>>;
  abstract deleteItemsByIds(ids: string[]): Promise<boolean>;
  abstract createFilterItem(item: CubiqTS.BlotterDefinitionImpl): Promise<boolean>;
  abstract updateFilterItem(item: CubiqTS.BlotterDefinitionImpl): Promise<boolean>;
}
